<template>
  <div
    class="notification-avatar-wrap"
    :style="wrapStyle"
  >
    <img
      v-if="image && !hasError"
      :src="image"
      :alt="alt"
      class="notification-avatar-img"
      referrerpolicy="no-referrer"
      @error="hasError = true"
    >
    <b-avatar
      v-else
      :text="initials"
      :size="size"
      variant="light-secondary"
    />
  </div>
</template>

<script>
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    initials: {
      type: String,
      default: 'N',
    },
    alt: {
      type: String,
      default: 'Notification',
    },
    size: {
      type: [Number, String],
      default: 42,
    },
  },
  data() {
    return {
      hasError: false,
    }
  },
  computed: {
    wrapStyle() {
      const dimension = typeof this.size === 'number' ? `${this.size}px` : this.size
      return {
        width: dimension,
        height: dimension,
        minWidth: dimension,
      }
    },
  },
  watch: {
    image() {
      this.hasError = false
    },
  },
}
</script>

<style scoped>
.notification-avatar-wrap {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.notification-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #f3f2f7;
}
</style>
